<template>

    <v-step :step="step" title="Actions">
        <div class="p-30">
            <transition name="modal">
                <v-modal-action-create v-if="showModal === 'add'" />
            </transition>
            <v-notice v-if="!actions.length" message="Add one or more actions." />
            <draggable v-else class="actions" v-model="actions" group="actions" handle=".handle" @start="drag=true" @end="drag=false" @update="sortActions">
                <v-action v-for="action in actions" :key="action.id" :action="action" />
            </draggable>
        </div>
        <template #footer>
            <v-button size="sm" @click.native="$store.commit('showModal', 'add')">Add Action</v-button>
        </template>
    </v-step>

</template>

<style scoped lang="scss">

    .actions {
        display: grid;
        gap: 5px;
    }

</style>

<script>

import ActionApi from '@api/ActionApi';
import draggable from 'vuedraggable'
import ModalActionCreate from '@modals/action/ModalActionCreate';
import Step from './Step';
import StepActionsAction from './StepActionsAction';

export default {

    components: {
        'draggable': draggable,
        'v-action': StepActionsAction,
        'v-modal-action-create': ModalActionCreate,
        'v-step': Step,
    },

    props: {
        step: {
            type: Number,
            default: 1,
        },
    },

    data() {
        return {
            loading: false,
            actions: [],
        }
    },

    mounted() {
        this.actions = this.campaign.actions;
    },

    computed: {

        campaign() {
            return this.$store.getters['campaign/campaign'];
        },

    },

    watch: {

        campaign: {
            deep: true,
            handler(val) {
                this.actions = val.actions;
            }
        },

    },

    methods: {

        sortActions() {
            this.$store.commit('loading', true);
            let params = { ids: this.actions.map(action => { return action.id }) }
            ActionApi.sortActions(this.campaign.id, params)
                .then((response) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('campaign/setActions', response.data.data);
                    this.$store.commit('setAlertSuccess', this.$t('message.saved'));
                })
                .catch((error) => {
                    this.$store.commit('loading', false);
                    this.$store.commit('setAlertWithError', error);
                });
        },

    },

}

</script>
